export default {
  data() {
    return {
      scrollposition: 0
    }
  },
  activated() {
    const mainContainer = document.getElementById('main-container')
    if (mainContainer) mainContainer.scrollTop = this.scrollposition
  },
  beforeRouteLeave(to, from, next) {
    const mainContainer = document.getElementById('main-container')
    if (mainContainer) this.scrollposition = mainContainer.scrollTop
    next()
  }
}
